import toggleClass from './helpers/toggleControlButtonClass'

import Controller from './Controller'

import getOwnersByState from './logic/getOwnersByState'
import styleFeatures from './logic/styleFeatures'

import addClickListener from './mapSetup/addClickListener'
import addHoverListener from './mapSetup/addHoverListener'
import addMenu from './mapSetup/addMenu'
import addSearchBox from './mapSetup/addSearchBox'
import renderMasthead from './mapSetup/renderMasthead'

import { categories as buttons } from './config/config'

const ViewController = {
  init(map, data, criteria) {
    // draw filter buttons
    // add reference
    this.filterButtons = addMenu(buttons, data, map)

    // setup global filterByOwner function
    // disavled in anonymous version
    // addFilterByOwner(data, map, criteria)

    // add Maps adress search
    addSearchBox(map)

    // draw map
    this.renderMap(map, data, criteria)

    // create global infowindow
    const infowindow = new google.maps.InfoWindow()

    // add event listeners to features
    addClickListener(data, map, infowindow)
    addHoverListener(map)

    this.renderControlsState(criteria)

    // render masthead or not
    renderMasthead()

    // hide loading-spinner
    const spinner = document.getElementsByClassName('spinner')
    spinner[0].style.display = 'none'
  },
  onMenuContainerClick(event) {
    const element = event.target
    element.className = toggleClass(element, 'hidden')
  },
  onMenuClick(event) {
    const siblings = [...event.target.parentNode.childNodes]

    // hide all open menu-sections
    siblings.forEach((el) => {
      if (el !== event.target) {
        ;[...el.childNodes][1].className = 'secondary-parent'
      }
    })

    // toggle menu-section
    const childElement = event.target.childNodes[1]
    childElement.className = toggleClass(childElement, 'expanded')
  },
  onFilterClick(event) {
    Controller.onFilterClick(event)
  },
  renderMap(map, data, criteria) {
    const newData = getOwnersByState(data, criteria, 'code2')
    map.data.setStyle(feature => styleFeatures(feature, newData))
  },
  renderControlsState(criteria) {
    const controls = this.filterButtons

    controls.forEach((control) => {
      const value = parseInt(control.dataset.value, 10)

      if (!criteria.includes(value)) {
        control.className = 'secondary-button inactive'
      } else {
        control.className = 'secondary-button'
      }
    })
  }
}

export default ViewController



// WEBPACK FOOTER //
// ./src/ViewController.js